
export interface UndoItemAwareInterface {
    id: string | number;
}

export interface HistoryItemInterface {
    current: string,
}


export class UndoService<TItem extends UndoItemAwareInterface> {

    private internalPosition: number = -1;
    private internalHistory: HistoryItemInterface[] = [];

    get canUndo(): boolean {
        return this.internalPosition > 0;
    }

    get canRedo(): boolean {
        return this.internalPosition < this.internalHistory.length - 1;
    }

    update(item: TItem, text?: string): HistoryItemInterface {

        if (this.redoInProgress || this.undoInProgress) {
            return null;
        }

        let stringified = JSON.stringify(item);

        if (this.internalHistory?.length === 0 || this.internalHistory[this.internalPosition].current !== stringified) {
            let record: HistoryItemInterface = {
                current: stringified,
            };
            this.addToHistory(record);

            return record;
        }

        return null;

    }

    initialize(item: TItem): void {
        this.internalHistory = [];
        this.update(item);
    }

    private undoInProgress = false;

    undo(): TItem {

        this.undoInProgress = true;
        if (!this.canUndo) {
            throw "Can't undo";
        }

        this.internalPosition -= 1;
        let record = JSON.parse(this.internalHistory[this.internalPosition].current);

        // Aspetto 300 ms per essere sicuro che durante la undo non si riaggiorni lo stato al property changed
        setTimeout(() => this.undoInProgress = false, 300)

        return record;
    }

    private redoInProgress = false;

    redo(): TItem {

        this.redoInProgress = true;
        if (!this.canRedo) {
            throw "Can't redo";
        }

        this.internalPosition += 1;
        const record = JSON.parse(this.internalHistory[this.internalPosition].current);

        // Aspetto 300 ms per essere sicuro che durante la redo non si riaggiorni lo stato al property changed
        setTimeout(() => this.redoInProgress = false, 300)

        return record;
    }

    getCurrentValue() {
        if (this.internalPosition >= 0) {
            return JSON.parse(this.internalHistory[this.internalPosition].current)
        }
        return null;
    }

    getPreviousValue() {
        if (this.internalPosition > 0) {
            return JSON.parse(this.internalHistory[this.internalPosition - 1].current)
        }
        return null;
    }

    private addToHistory(record: HistoryItemInterface): void {
        while (this.canRedo) {
            this.internalHistory.pop();
        }
        this.internalHistory.push(record);
        this.internalPosition += 1;
    }
}
